import React from "react";
import { Outlet } from "react-router-dom";
import { LoadingModalContext, useLoadingModal } from "@/shared/components/loading/loading-context";
import { LoadingModal } from "@/shared/components/loading/loading-modal";
import { LoginProvider } from "@/features/auth/contexts/login-context";
import { ModalProvider } from "@/shared/components/modal/contexts/modal-context";

export const BaseNotLoginLayout = () => {
  // ローディング用コンテキスト
  const ctx = useLoadingModal();

  return (
    <LoadingModalContext.Provider value={ctx}>
      <LoginProvider>
        <ModalProvider>
          <Outlet />
          <LoadingModal />
        </ModalProvider>
      </LoginProvider>
    </LoadingModalContext.Provider>
  );
};
